export default {
  path: '/clientes',
  component: () => import('@/components/pages/Clients/Clients.vue')
}
